import React from 'react'
import Filters from './filters'
import List from './list'
import Unauthorized from '../../common/unauthorized'
import { 
    ExperienceScreenContext,
    useExperienceScreenContext
} from './use-experience-screen';
import { MassEditModalsProvider } from '../mass-edit-modals';

const ExperiencesScreen = () => {
    const context = useExperienceScreenContext();
    const { isPermitted } = context;

    if (!isPermitted) {
        return (
            <Unauthorized />
        )
    }

    return (
        <ExperienceScreenContext.Provider value={context}>
            <MassEditModalsProvider>
                <Filters value={context.filters} onChange={context.setFilters} />
                <List filters={context.filters} />
            </MassEditModalsProvider>
        </ExperienceScreenContext.Provider>
    )
}

export default ExperiencesScreen